import React from "react";
import MenuList from "../navigation/MenuList";
export var RetailLeftRail = function RetailLeftRail(props) {
  var _props$fields = props.fields,
      fields = _props$fields === void 0 ? {} : _props$fields;
  var _fields$items = fields.items,
      items = _fields$items === void 0 ? [] : _fields$items;
  var mappedLeftRail = mapLeftRail(items);
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-retail__left-rail"
  }, mappedLeftRail.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: 'cb-menu__nav' + index,
      className: "cb-menu__nav"
    }, /*#__PURE__*/React.createElement(MenuList, {
      key: 'cb-menu__list' + index,
      item: item
    }));
  }));
};

var mapLeftRail = function mapLeftRail(data) {
  var items = Array.isArray(data) ? data.map(function (item) {
    return {
      navigationTitle: {
        value: item.displayName
      },
      url: item.categoryContentPagePath,
      children: mapLeftRail(item.categories)
    };
  }) : [];
  return items;
};